import * as React from 'react';

import classNames from 'classnames';
import Slider from 'react-slick';

import { ERefsApps } from '@enums';

import { IShowcaseStore } from '@stores';

import { AppsList, ContentPanel, EAppItemType } from '@components';

import * as s from './style/Panel.scss';

interface IPanel {
	store: IShowcaseStore;
	isVisible?: boolean;
}

export const AppsShowcase = ({
	store,
	isVisible,
}: IPanel) => {
	const apps = 'data' in store ? (store).data?.apps : [];
	const status = 'status' in store ? store.status : null;
	const [isLoaded, setIsLoaded] = React.useState(false);

	if (!isVisible) {
		return null;
	}

	const renderSlider = (state: boolean) => (array: JSX.Element[]) => {
		const sliderClass = classNames(
			s.slider,
			s.carousel,
			{ [s.slider_loaded]: state },
		);

		return <Slider
			className={ sliderClass }
			autoplay={true}
			autoplaySpeed={4000}
			arrows={false}
			dots={false}
			slidesToShow={1}
			centerPadding={'0px'}
			centerMode
			swipeToSlide
			draggable
			variableWidth={true}
			onInit={() => setIsLoaded(true)}
		>
			{array}
		</Slider>;
	};

	return <ContentPanel
		className={s.showCase}
	>
		<AppsList
			appItemClassName={s.slide}
			type={EAppItemType.LARGE}
			renderCustomAppsList={renderSlider(isLoaded) }
			apps={apps}
			responseStatus={status}
			urlRef={ERefsApps.LINE_SHOWCASE}
		/>

	</ContentPanel>;
};
